/**
 * @file protocal
 * @author zhaomiaoyuan
 */
import React from 'react';
import Checkbox from 'antd/lib/checkbox';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons';
import './index.less';
interface Props {
    type: string;
    data: any;
    updateData?: any;
    onChange?: any
}

export default function AgreeProtocol(props: Props) {
    const {
        type,
        data,
        updateData,
        onChange
    } = props;
    function protocolChange(e) {
        updateData && updateData({
            [type]: e.target.checked,
            [type + 'Err']: ''
        });
        onChange && onChange(e);
    }
    return (
        <div className="agree-protocol">
            <Checkbox checked={data[type]} className="checkbox" onChange={protocolChange}></Checkbox>
            <p>
                阅读并同意
                <a
                    className="link"
                    href="https://haoma.baidu.com/privacy/agreement.html"
                    rel="noopener noreferrer"
                    target="_blank"
                >《企业号码认证服务协议》</a>和
                <a
                    className="link"
                    href="https://haoma.baidu.com/privacy/index.html"
                    rel="noopener noreferrer"
                    target="_blank"
                >《百度号码认证服务隐私政策》</a>
            </p>
            {data[type + 'Err'] && <p className="agree-protocol-err">
                <ExclamationCircleOutlined style={{marginRight: '4px'}} />
                {data[type + 'Err']}</p>}
        </div>
    );
}
